import React from 'react';
import { CTAButton } from './ui/CTAButton';
import { ShieldCheckIcon, LockIcon, CreditCardIcon, ZapIcon } from 'lucide-react';
export function PricingSection() {
  return <section id="compra" className="py-14 md:py-24 px-4 bg-brand-light scroll-mt-10" data-id="element-208">
      <div className="max-w-2xl mx-auto" data-id="element-209">
        <div className="text-center mb-6 md:mb-10" data-id="element-210">
          <h2 className="text-3xl md:text-5xl font-black text-brand-dark mb-3" data-id="element-211">
            💰 Elegí tu MegaPack
          </h2>
          <p className="text-xl md:text-2xl font-bold text-brand-blue" data-id="element-212">
            Precio de Lanzamiento — Hasta agotar cupos
          </p>
        </div>

        {/* Single Product Card */}
        <div className="bg-white shadow-xl border-3 border-brand-orange ring-2 ring-brand-orange rounded-2xl p-5 md:p-8 relative mb-8" data-id="element-213">
          <div className="absolute -top-3 left-4 bg-brand-orange text-white font-black px-3 py-0.5 rounded-full text-[10px] md:text-xs tracking-wider shadow-md" data-id="element-214">
            ⭐ OFERTA DE LANZAMIENTO
          </div>

          <div className="text-center mb-6" data-id="element-215">
            <h3 className="text-2xl md:text-3xl font-black text-brand-dark flex items-center justify-center gap-2 mb-2" data-id="element-216">
              🔨 PACK PROFESIONAL
            </h3>
            <p className="text-sm md:text-base text-gray-600 font-medium" data-id="element-217">
              52 cursos + softwares + manuales + seguridad + 3 bonos
            </p>
          </div>

          {/* Price highlight */}
          <div className="text-center mb-6 bg-brand-light p-4 rounded-xl" data-id="element-218">
            <p className="text-gray-400 text-lg line-through font-bold mb-1" data-id="element-219">
              $49.900 ARS
            </p>
            <div className="flex items-center justify-center gap-2" data-id="element-220">
              <span className="text-5xl md:text-6xl font-black text-brand-orange" data-id="element-221">
                $19.990
              </span>
              <span className="text-lg text-gray-500 font-medium" data-id="element-222">ARS</span>
            </div>
            <p className="text-brand-green font-black text-lg mt-2" data-id="element-223">
              🔥 Ahorrás $29.910 — 60% OFF
            </p>
          </div>

          {/* Details */}
          <div className="space-y-2 mb-6" data-id="element-224">
            {['52 cursos profesionales de minería', 'Softwares originales incluidos', 'Biblioteca técnica completa (+39 manuales + 38 libros)', 'Capacitaciones de seguridad minera', 'Los 3 Bonos Estratégicos', 'Actualizaciones de por vida', 'Acceso ilimitado vía Google Drive'].map((d, i) => <p key={i} className="text-xs md:text-sm text-gray-700 flex items-start gap-2 leading-relaxed" data-id="element-225">
                <span className="text-brand-green flex-shrink-0 mt-0.5" data-id="element-226">
                  ✅
                </span>{' '}
                <span data-id="element-227">{d}</span>
              </p>)}
          </div>

          <div className="bg-red-50 border border-red-200 rounded-lg p-3 text-center mb-2" data-id="element-228">
            <p className="text-red-600 font-bold text-sm" data-id="element-229">
              ⚠️ Precio válido solo hasta agotar cupos de lanzamiento
            </p>
          </div>
        </div>

        {/* CTA Button */}
        <div className="mb-8" data-id="element-230">
          <CTAButton text="→ QUIERO MI MEGAPACK AHORA" href="https://checkout.guiadigital360.online/cart/44819876446277:1" isLink={true} data-id="element-231" />
        </div>

        {/* Trust Badges */}
        <div className="flex flex-wrap justify-center items-center gap-4 md:gap-8 text-xs md:text-sm text-gray-600 font-bold bg-white py-4 px-4 rounded-2xl shadow-sm border border-gray-100" data-id="element-232">
          <span className="flex items-center gap-1.5" data-id="element-233">
            <LockIcon className="w-4 h-4 md:w-5 md:h-5 text-gray-500" data-id="element-234" /> Pago
            seguro
          </span>
          <span className="flex items-center gap-1.5" data-id="element-235">
            <ZapIcon className="w-4 h-4 md:w-5 md:h-5 text-yellow-500" data-id="element-236" /> Acceso
            en 5 min
          </span>
          <span className="flex items-center gap-1.5" data-id="element-237">
            <ShieldCheckIcon className="w-4 h-4 md:w-5 md:h-5 text-brand-green" data-id="element-238" />{' '}
            Garantía 7 días
          </span>
          <span className="flex items-center gap-1.5" data-id="element-239">
            <CreditCardIcon className="w-4 h-4 md:w-5 md:h-5 text-blue-500" data-id="element-240" />{' '}
            Mercado Pago
          </span>
        </div>
      </div>
    </section>;
}